/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Related_InvalidInputs */

const vi_error_shop_related_invalid = /** @type {(inputs: Error_Shop_Related_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không chọn chính nhóm này làm nhóm liên quan.`)
};

/**

* @param {Error_Shop_Related_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_related_invalid = /** @type {((inputs?: Error_Shop_Related_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Related_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_related_invalid(inputs)
});